import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const ReviewsSection = props => {
  const { languageData, spaceComments } = props;

  const comments = spaceComments || [];

  const renderStars = stars => {
    const full = '★'.repeat(stars || 0);
    const empty = '☆'.repeat(5 - (stars || 0));
    return full + empty;
  };

  return (
    <FlexContainer className="bgGradientReviewBlue180 borderrad14 flex-column pad20">
      <Label className="text-18" style={{ fontWeight: 600 }}>
        {languageData === 'EN' ? 'Reviews' : 'Opiniones'} ({comments.length})
      </Label>

      <Label className="text-12 margt4" style={{ opacity: 0.7 }}>
        {languageData === 'EN'
          ? `${comments.length} Ratings`
          : `${comments.length} Calificaciones`}
      </Label>

      {comments.length > 0 ? (
        comments.map((comment, index) => {
          let profileImage = '';

          try {
            const parsed = JSON.parse(comment.main_image);
            if (Array.isArray(parsed) && parsed.length > 0) {
              profileImage = parsed[0];
            }
          } catch {
            profileImage = comment.main_image;
          }

          return (
            <FlexContainer key={index} className="width100 flex-column margt20">
              <FlexContainer className="align-items-center margb10">
                {profileImage ? (
                  <img
                    src={profileImage}
                    alt={comment.user_name}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <div className="width-40px height-40px borderRad50 bgGray025"></div>
                )}

                <FlexContainer className="flex-column margl10">
                  <div className="text-16 fontWhite">
                    {renderStars(comment.comment_stars)}
                  </div>

                  <Label className="text-13 margt2">
                    {comment.user_name} {comment.user_lastname || ''}
                  </Label>
                </FlexContainer>
              </FlexContainer>

              <Label
                className="text-12 lineHeight-1-5"
                style={{ opacity: 0.9 }}
              >
                {comment.comment_detail}
              </Label>

              {index + 1 < comments.length && (
                <div
                  className="width100 height-1px margt20"
                  style={{
                    background: 'rgb(255,255,255,0.4)',
                  }}
                />
              )}
            </FlexContainer>
          );
        })
      ) : (
        <Label className="text-14 margt20">
          {languageData === 'EN' ? 'No reviews yet' : 'Aún no hay opiniones'}
        </Label>
      )}
    </FlexContainer>
  );
};

export default ReviewsSection;
